import { TMe } from 'app/types/entities/TMe';
import { TRepository } from 'app/types/entities/TRepository';

export function checkAssignedRepositories(me: TMe, organizationId: string) {
  return (me.assignedRepositories || []).filter((repo: TRepository) => repo.organizationId === organizationId);
}
